import $api from "@/frontend/shared/api/axios";
import { TGetAnnotationsData } from "../types/types";

export async function postAnnotation({
  companyId,
  content,
  replyToId,
  organizationId
}: {
  companyId: number;
  content: string;
  replyToId?: number;
  organizationId?: number;
}): Promise<TGetAnnotationsData> {
  const response = await $api.post("/companies/annotations", {
    companyId,
    content,
    replyToId,
    organizationId
  });
  return response.data.data;
}
